<template>
  <div :class="styles">
    <h6
      v-if="booking.booking_status !== 'pending' && booking.booking_status !== 'cancelled'"
      class="details_items"
    >
      <i class="icon-home" />
      {{ booking.store.name }}
      <span
        class="small"
        style="white-space: nowrap"
      />
    </h6>

    <!--    UBICACIÓN    -->
    <h6
      v-if="showLocation"
      class="details_items"
    >
      <i class="icon-location-2" />
      {{ $t('lang.stores.location') }}:
      <span
        v-if="booking.booking_status === 'pending' || booking.booking_status === 'cancelled'"
        class="small"
      >{{ $t('lang.bookings.exact_location') }}
      </span>
      <span
        v-else
        class="small"
      >
        <span v-if="booking.store.address_description">
          {{ booking.store.address_description }},
        </span>
        {{ booking.store.full_address }}
        <a
          class="ml-2"
          :href="mapUrl"
          target="_blank"
        >
          <small class="m-0">{{ $t('lang.bookings.open_map') }}</small>
        </a>
      </span>
    </h6>

    <!--    FECHA INGRESO    -->
    <h6 class="details_items">
      <i class="icon-right-big" />
      {{ $t('lang.bookings.start_date') }}:
      <span
        class="small"
        style="white-space: nowrap"
      >{{ formatDate(booking.start_date) }}hs.

        <b-link
          v-if="allowModification"
          href="#"
          class="color-secondary"
          :title="$t('lang.bookings.modify_booking')"
          @click="openStartDate()"
        >
          <i class="icon-pencil-neg" />
        </b-link>
      </span>

      <datetime
        v-if="allowModification"
        v-model="inputStartDate"
        input-id="start_date"
        type="datetime"
        style="height: 0"
        input-style="border: none; font-size: 0"
        :value="now"
        :hour-step="1"
        :minute-step="30"
        :min-datetime="now"
        :week-start="7"
        :format="{
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        }"
        :phrases="{
          ok: $t('lang.search.calendar_continue'),
          cancel: $t('lang.search.calendar_cancel'),
        }"
        auto
        required
        @close="closeStartDate"
      />
    </h6>

    <!--    FECHA RETIRO    -->
    <h6 class="details_items">
      <i class="icon-left-big" />
      {{ $t('lang.bookings.end_date') }}:
      <span
        class="small"
        style="white-space: nowrap"
      >{{ formatDate(booking.end_date) }}hs.

        <b-link
          v-if="allowModification"
          href="#"
          class="color-secondary"
          :title="$t('lang.bookings.modify_booking')"
          @click="openEndDate()"
        >
          <i class="icon-pencil-neg" />
        </b-link>

      </span>

      <datetime
        v-if="allowModification"
        v-model="inputEndDate"
        input-id="end_date"
        type="datetime"
        style="height: 0"
        input-style="border: none; font-size: 0"
        :hour-step="1"
        :minute-step="30"
        :min-datetime="minEndDate"
        :week-start="7"
        :format="{
          year: 'numeric',
          month: 'long',
          day: 'numeric',
          hour: 'numeric',
          minute: '2-digit'
        }"
        :phrases="{
          ok: $t('lang.search.calendar_continue'),
          cancel: $t('lang.search.calendar_cancel')
        }"
        :placeholder="$t('lang.search.end_date')"
        auto
        required
        @close="closeEndDate"
      />
    </h6>

    <!--    VALIJAS    -->
    <h6
      v-if="origin !== 'card' && !booking.store.is_locker"
      class="details_items"
    >
      <i class="icon-suitcase" />

      <div
        v-if="editBagsNumber"
        class="btn-group ml-2 p-0 show"
      >
        <button
          type="button"
          class="btn btn-light dropdown-toggle p-1"
          data-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="true"
        >
          {{ booking.bags_number }} {{ $tc('lang.bookings.bags', booking.bags_number ) }}
        </button>
        <div
          class="dropdown-menu pre-scrollable prices-dropdown show"
          style="max-height: 200px;"
        >
          <button
            v-for="i in 20"
            :key="'bags_'+i"
            class="dropdown-item"
            type="button"
            @click="changeBagsNumber(i)"
          >
            <b v-if="i===booking.bags_number">

              {{ i }} {{ $tc('lang.bookings.bags', i ) }}
            </b>
            <span v-else>
              {{ i }} {{ $tc('lang.bookings.bags', i ) }}</span>
          </button>
        </div>
      </div>

      <span v-else>
        {{ booking.bags_number }} {{ $tc('lang.bookings.bags', booking.bags_number ) }}
      </span>
      <span class="small">
        <b-link
          v-if="allowModification"
          href="#"
          class="color-secondary"
          :title="$t('lang.bookings.modify_booking')"
          @click="editBagsNumber=true"
        >
          <i class="icon-pencil-neg" />
        </b-link>
      </span>
    </h6>

    <!--    PRECIOS    -->
    <h6
      v-if="origin !== 'card' && !booking.store.is_locker"
      class="details_items mb-2 mt-n1"
    >
      <i class=" icon-dollar" />
      {{ $t('lang.search.prices.booking_price') }}
      <span
        class="small"
        style="white-space: nowrap"
      >
        <div
          v-if="showCurrencyOptions"
          class="btn-group ml-2 p-0"
        >
          <button
            type="button"
            class="btn btn-light dropdown-toggle p-1"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <span class="small">{{ $globalPrices[booking.currency].symbol }} </span>
          </button>
          <div class="dropdown-menu prices-dropdown">
            <button
              v-for="(currency_id, index) in booking.store.available_currencies"
              :key="index"
              class="dropdown-item"
              type="button"
              @click="changeCurrency(currency_id)"
            >
              <b class="pr-1">{{ $globalPrices[currency_id].symbol }}</b>
              {{ $t('lang.navbar.currency_'+currency_id) }}
            </button>
          </div>
        </div>
        <span v-else> {{ $globalPrices[booking.currency].symbol }} </span>

        <span class="small_h6"> {{ Number(booking.total_price).toLocaleString('de-DE') }}</span>

        <span
          v-if="booking.discount_code === discountCode"
          class="color_text"
        > &nbsp; * 20 OFF</span>

        <span
          v-if="origin === 'details'"
          class="mb-0"
        >
          <b-link
            href="#"
            class="ml-2"
            @click="showPricesDetails = !showPricesDetails"
          >
            <small v-if="showPricesDetails">
              {{ $t('lang.search.prices.hide_price_info_title') }}
            </small>
            <small v-else>
              {{ $t('lang.search.prices.price_info_title') }}
            </small>
          </b-link>
        </span>
      </span>
    </h6>

    <!--    DETALLE PRECIOS    -->
    <table
      v-if="showPricesDetails"
      class="table table-sm"
    >
      <tbody>
        <tr
          v-for="bookingItem in booking.booking_items"
          :key="bookingItem.id"
        >
          <td class="text-left">
            {{ bookingItem.quantity +' '+
              $tc('lang.bookings.' + bookingItem.price_list.sku, bookingItem.quantity) }}
          </td>
          <td class="text-center">
            {{ $globalPrices[booking.currency].symbol
              +' '+ Number(bookingItem.price_list.unit_price).toLocaleString('de-DE')
              +' x '+ $tc('lang.bookings.bags', 1) +' x '+ bookingItem.days
              +' '+ $tc('lang.bookings.days', bookingItem.days )
            }}
          </td>
          <td class="text-right">
            {{ $globalPrices[booking.currency].symbol + Number(bookingItem.subtotal).toLocaleString('de-DE') }}
          </td>
        </tr>

        <tr v-if="booking.discount_code">
          <td class="text-left">
            {{ $t('lang.bookings.promo_code') }}
          </td>
          <td
            v-if="booking.discount_code === discountCode"
            class="text-center"
          >
            {{ $t('lang.search.prices.long_booking_discount') }}
          </td>
          <td
            v-else
            class="text-center"
          >
            {{ booking.discount_code }}
          </td>
          <td class="text-right">
            - {{ $globalPrices[booking.currency].symbol }} {{ Number(booking.discount_amount).toLocaleString('de-DE') }}
          </td>
        </tr>

        <tr>
          <th class="text-left">
            {{ $t('lang.bookings.total') }}
          </th>
          <th class="text-center" />
          <th class="text-right">
            <b>{{ $globalPrices[booking.currency].symbol }} {{ Number(booking.total_price).toLocaleString('de-DE') }}</b>
          </th>
        </tr>
      </tbody>
    </table>

    <!--    PRECINTOS    -->
    <h6
      v-if="origin !== 'card' && booking.booking_status === 'at_store'"
      class="details_items"
    >
      <i class="icon-tag-1" />
      {{ $t('lang.bookings.security_seals') }}
      <span
        v-for="(seal, index) in booking.booking_bag_security_elements"
        :key="seal.security_seal"
        class="small"
      >
        <span v-if="index>0">-</span>
        {{ seal.security_seal }}
      </span>
    </h6>

    <!--    ESTADO    -->
    <h6 class="details_items">
      <span
        :class="statusClass"
        class="booking-badge"
      >
        {{ $t('lang.bookings.status.' + booking.booking_status).toUpperCase() }}
      </span>
      <span
        v-if="booking.booking_status === 'confirmed' && booking.store.is_locker"
        class="ml-2"
      >
        <span class="badge badge-pill badge-warning booking-badge mr-2">
          <i class="fas fa-lock" />&nbsp;&nbsp; {{ $t('lang.lockers.badge') }}
        </span><br>
        <span class="small">{{ booking.store.new_booking_automatic_message }}</span>
      </span>
      <span
        v-else
        class="small ml-1"
      >
        {{ $t('lang.bookings.status_text.' + booking.booking_status) }}
      </span>
    </h6>

    <LockerOptions
      v-if="booking.store.is_locker"
      :lockers="booking.store.lockers"
      :booking="booking"
      @lockerSelectionChanged="lockersSelected"
    />
    <!--    RECLAMO    -->
    <h6
      v-if="booking.claim"
      class="details_items"
    >
      <i class="icon-attention-3 text-danger" />
      <span class="small">{{ $t('lang.bookings.have_claim') }}</span>
    </h6>
  </div>
</template>

<script>
import { Datetime } from 'vue-datetime';

// You need a specific loader for CSS files
import '../../assets/css/vue-datetime.min.css';
import LockerOptions from '@/components/Store/LockerOptions.vue';

export default {
  name: 'BookingInfo',
  components: {
    LockerOptions,
    datetime: Datetime,
  },

  props: {
    booking: {
      type: Object,
      required: true,
    },
    styles: {
      type: String,
      default: null,
    },
    allowModification: {
      type: Boolean,
      default: false,
    },
    origin: {
      type: String,
      default: 'card',
    },
  },

  data() {
    return {
      start_date: null,
      end_date: null,
      inputStartDate: '',
      inputEndDate: '',
      minEndDate: '',
      now: new Date(
        ((new Date()).setMinutes((new Date()).getMinutes())),
      ).toISOString(), // Now in the correct timezone
      showPricesDetails: false,
      editBagsNumber: false,
      mapUrl: `https://www.google.com/maps/dir/?api=1&destination=${this.booking.store.latitude_coordinate},${this.booking.store.longitude_coordinate}`,
      discountCode: process.env.VUE_APP_DISCOUNT_CODE_FOR_LONG_BOOKINGS,
    };
  },

  computed: {
    statusClass() {
      let classColor = 'none';
      const status = this.booking.booking_status;

      switch (status) {
        case 'pending':
          classColor = 'warning';
          break;
        case 'claimed':
          classColor = 'danger';
          break;
        case 'at_store':
          classColor = 'primary';
          break;
        case 'confirmed':
          classColor = 'success';
          break;
        case 'closed':
          classColor = 'secondary';
          break;
        case 'cancelled':
          classColor = 'dark';
          break;
        default:
          break;
      }
      return `badge badge-pill badge-${classColor}`;
    },

    showCurrencyOptions() {
      if (this.booking.booking_status === 'pending'
          && this.booking.store.available_currencies
          && this.booking.store.available_currencies.length > 1
          && this.styles !== 'small_info') {
        return true;
      }
      return false;
    },

    showLocation() {
      if (this.origin !== 'card') {
        return true;
      }
      if (this.origin === 'card' && (this.booking.booking_status === 'confirmed' || this.booking.booking_status === 'at_store')) {
        return true;
      }
      return false;
    },
  },

  watch: {
    booking() {
      this.limitDates();
    },
  },

  created() {
    this.limitDates();
  },

  methods: {
    formatDate(date) {
      const options = {
        // weekday: 'long',
        // year: 'numeric',
        month: 'long',
        day: 'numeric',
        hour: 'numeric',
        minute: '2-digit',
        hour12: false,
      };

      const { lang } = this.$store.state.main;

      let stringDate = new Date((`${date}`).replace(/-/g, '/')); // Replace function needed to work on Safari
      stringDate = stringDate.toLocaleDateString(lang, options);

      return stringDate;
    },

    limitDates() {
      // Si la fecha de inicio de la reserva es antes de hoy, no deja elegir desde hoy
      const startDate = new Date(this.booking.start_date).toISOString();
      this.minEndDate = startDate;

      if (this.now > startDate) {
        this.minEndDate = this.now;
      }
    },

    openStartDate() {
      this.inputStartDate = null;
      this.inputEndDate = null;
      document.getElementById('start_date').focus();
    },
    closeStartDate() {
      if (this.inputStartDate) {
        const updatedData = { startDate: this.inputStartDate };
        this.$emit('updateSchedules', updatedData);
      }
    },

    openEndDate() {
      this.inputStartDate = null;
      this.inputEndDate = null;
      document.getElementById('end_date').focus();
    },
    closeEndDate() {
      if (this.inputEndDate) {
        const updatedData = { endDate: this.inputEndDate };
        this.$emit('updateSchedules', updatedData);
      }
    },

    changeBagsNumber(value) {
      const updatedData = { bagsNumber: value };
      this.$emit('updateSchedules', updatedData);
    },

    changeCurrency(value) {
      this.$store.dispatch('setCurrency', value);
      const updatedData = { currency: value };
      this.$emit('updateSchedules', updatedData);
    },

    lockersSelected(selection) {
      const updatedData = { lockers: selection };
      this.$emit('updateSchedules', updatedData);
    },

  },
};
</script>
